import axios from "axios";
import { SERVICE_URL } from "../ServiceUrls";
import { store } from "../Store";
import { exclusiveBookActions } from "../Slices/ExclusiveBookSlice";
import { getRandomImageForExclusiveBook } from "../../Util";

export const fetchAllExclusiveBooks = async (dispatch, limit = 16, page = 1) => {
  const filter = {
    limit: limit,
    offset: (page - 1) * limit,
  };

  try {
    const response = await axios({
      url: `${SERVICE_URL.EXCLUSIVEBOOK}?filter=${encodeURIComponent(JSON.stringify(filter))}`,
      method: "get",
      responseType: "json",
    });

    if (response.data.success) {
      dispatch(exclusiveBookActions.updateBooks(response.data.data));
      return { data: response.data.data, total: response.data.total };
    }
    return { data: [], total: 0 };
  } catch (error) {
    console.error(error);
    return { data: [], total: 0 };
  }
};

export const fetchAllExclusiveBooksCount = async (dispatch) => {
  try {
    const response = await axios({
      url: `${SERVICE_URL.EXCLUSIVEBOOK}/count`,
      method: "get",
      responseType: "json",
    });

    if (response.data.success) {
      return response.data.data;
    }
    return 0;
  } catch (error) {
    console.error(error);
    return 0;
  }
};

export const fetchExclusiveBookById = (id,dispatch) => {
  return axios({
    url:`${SERVICE_URL.EXCLUSIVEBOOK}/${id}`,
    method:"get"
  }).then(res => {
    if(res.data.success){
      dispatch(exclusiveBookActions.updateBookById(res.data.data));
      return res.data.data;
    }
  }).catch(err => {
    console.error(err)
  }) 
}

export const fetchExclusiveBookByTitle = (title,dispatch) => {
  return axios({
    url:`${SERVICE_URL.EXCLUSIVEBOOK}/title/${title}`,
    method:"get"
  }).then(res => {
    if(res.data.success){
      dispatch(exclusiveBookActions.updateBookById(res.data.data));
      return res.data.data;
    }
  }).catch(err => {
    console.error(err)
  }) 
}

export const fetchExclusiveBook = (
  dispatch,
  filter
) => {

  return axios({
    url: `${SERVICE_URL.EXCLUSIVEBOOK}?filter=${encodeURIComponent(
      JSON.stringify(filter)
    )}`,
    method: "get",
    responseType: "json",
  })
    .then((response) => {
      if (response.data.success) {
        const booksData = response.data.data;
        const addRandomImagesToBookData = booksData.map((data) =>  {
          const randomImageData = getRandomImageForExclusiveBook(data);
          return { 
          ...data, 
          imageUrl: randomImageData?.image, 
          color: randomImageData?.color, 
        }});
        if(dispatch) {
          dispatch(exclusiveBookActions.updateBooks(addRandomImagesToBookData));
        }
        return { data: addRandomImagesToBookData, total: response.data.total };
      }
      return { data: [], total: 0 };
    })
    .catch((error) => {
      console.error(error);
      return { data: [], total: 0 };
    });
};
export const fetchExclusiveBookCount = (
  field,
  query,
  minPublishingYear,
  maxPublishingYear,
  selectedGenre,
  additionalQuery
) => {
  let filter = {
    where: {
      $and: [],
    },
  };

  let updatedQuery = query;
  if(query && query !== "") {
    updatedQuery = `"${updatedQuery}"`
    query = updatedQuery;
  }

  if (!additionalQuery) {
    
    if (field !== "all" && query && query !== "") {
      filter.where.$and.push({ [field]: query });
    } else if (query) {
      filter.where.$and.push({
        $or: [{ author: query }, { title: query }, { language: query },{ sku: query },{ isbnNo: query }],
      });
    }

    // Add publishingYear range condition in the format "MIN TO MAX"
    if (minPublishingYear || maxPublishingYear) {
      const publishingYearCondition = {
        publishingYear: `[${minPublishingYear || "*"} TO ${
          maxPublishingYear || "*"
        }]`,
      };
      filter.where.$and.push(publishingYearCondition);
    }

    // Add genre condition if selectedGenre is provided
    if (selectedGenre && selectedGenre?.length > 0) {
      filter.where.$and.push({ genres: selectedGenre.join(",") });
    }
  } else if(query) {
    filter.where.$and.push({
      $or: [{ author: query }, { title: query }, { language: query }],
    });

    // Add additional query conditions
    if (additionalQuery) {
      filter.where.$and.push({
        $or: [
          { author: additionalQuery },
          { title: additionalQuery },
          { language: additionalQuery },
          { sku: additionalQuery },
          { isbnNo: additionalQuery },
        ],
      });
    }

    // Add publishingYear range condition in the format "MIN TO MAX"
    if (minPublishingYear || maxPublishingYear) {
      const publishingYearCondition = {
        publishingYear: `[${minPublishingYear || "*"} TO ${
          maxPublishingYear || "*"
        }]`,
      };
      filter.where.$and.push(publishingYearCondition);
    }

    // Add genre condition if selectedGenre is provided
    if (selectedGenre && selectedGenre?.length>0) {
      filter.where.$and.push({ genres: selectedGenre.join(",") });
    }
  }

  return axios({
    url: `${SERVICE_URL.EXCLUSIVEBOOK}/count?filter=${encodeURIComponent(
      JSON.stringify(filter)
    )}`,
    method: "get",
    responseType: "json",
  })
    .then((response) => {
      if (response.data.success) {
        return response.data.data;
      }
    })
    .catch((error) => {
      console.error(error);
      return null;
    });
};


export const getFacets = () => {
  return axios({
    url: `${SERVICE_URL.EXCLUSIVEBOOK}/facets`,
    method: "get",
    responseType: "json",
  }).then((response) => {
    if (response.data.success) {
      return response.data.data;
    }
  });
};

export const getSuggestionsForExclusiveBooks = async (query, field = "all",
  limit
  ) => {

    try {
      const params = { query, field, limit };
  
      const response = await axios.get(`${SERVICE_URL.EXCLUSIVEBOOK}/suggest`, { params });
  
      if (response.data.success) {
        return response.data.data; 
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
      return [];
    }
}